import { useContext } from "react";
import { ENUM_ELEMENT_ID } from "../../components/common/enums";
import { CanvasContextRef, VideoContextRef } from "../../pages/CurrentModel.jsx";
import { useAppSelector } from "../../store/index.ts";
import { cancelFs, requestFs } from "../../utils/utils";

export default function useFullScreen() {
  const videoRef = useContext(VideoContextRef);
  const canvasRef = useContext(CanvasContextRef);
  const isFullScreen = useAppSelector((state) => state.common.flags.foolScreen);

  const makeFullScreen = async (e) => {
    e?.stopPropagation?.();

    const chatBroadcaster = document.querySelector(`#${ENUM_ELEMENT_ID.chatBroadcaster}`);
    const zoomistContainer = document.querySelector(`#${ENUM_ELEMENT_ID.zoomistContainer}`);
    if (chatBroadcaster?.style) chatBroadcaster.style.maxHeight = "100%";
    if (zoomistContainer?.style) zoomistContainer.style.height = "auto";

    if (isFullScreen) return cancelFs();

    const elem = document.querySelector(`#${ENUM_ELEMENT_ID.chatContent}`);
    await requestFs(elem, videoRef?.current);

    if (canvasRef?.current?.style?.height) canvasRef.current.style.height = "100%";
  };

  return { makeFullScreen };
}
